import React from 'react';

function SelectHeader({ name, options, selected, value, defaultOption, additionalClasses, variant, size, invalid, ...rest }) {

    let className = "outline-none ring-0 focus:outline-none focus:ring-0";

    if (!!size) {
        switch (size) {
            case "small":
                className += " py-0.5 leading-6";
                break;
            default:
                className += " py-1 leading-7";
                break;
        }
    }

    if (invalid) {
        className += " border-red-700 focus:border-red-700 ";
    } else {
        switch (variant) {
            case "primary":
                className += ` border-purple text-white focus:border-purple text-sm font-semibold ${!!value && value === "listing" ? `w-24` : `w-28` }`;
                break;
            case "secondary":
                className += " border-yellow bg-yellow text-gray-darkest focus:border-yellow-darker";
                break;
            default:
                className += " border-purple text-gray-darkest";
                break;
        }
    }

    className += " " + additionalClasses;

    return (
        <select name={name} value={String(value)} className={className} {...rest}>
            {!!defaultOption && <option value="">{defaultOption}</option>}
            {options && options.map(option => !!option && <option value={option.id} key={option.id}>{option.name}</option>)}
        </select>
    );
}

export default SelectHeader;
